import React from "react";

const ImageReservationContent = ({ reservation, isUpdate = false }) => {
    if (!reservation) return null;
    const data = isUpdate ? (reservation?.new ?? reservation?.old ?? {}) : reservation;

    const rows = Object.entries(data).map(([key, value], index) => (
        <tr key={index} className="text-left">
            <td style={{width: "30%"}}>{key}</td>

            <td className={"transform translate-x-[5px]"} style={{width: isUpdate ? "35%" : "70%"}}>
                {isUpdate ? reservation?.new?.[key] ?? "" : value}
            </td>

            {isUpdate && (
                <td className={"transform translate-x-[8px]"} style={{width: "35%"}}>
                    {reservation?.old?.[key] ?? ""}
                </td>
            )}
        </tr>
    ));

    return (
        <tr className="bg-white image-reservation-table">
            <td colSpan={3} className={'transform -translate-x-[8px]'}>
                <table className="w-full">
                    <thead>
                        <tr className="text-left">
                            <th colSpan={3}>Reserva de imagem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default ImageReservationContent;